<template>
  <div class="region-list">
    <div class="regions-grid">
      <div
        v-for="region in regionsWithData"
        :key="region.id"
        class="region-card"
        :class="region.name.toLowerCase().replace(' ', '-')"
        @click="selectRegion(region)"
      >
        <!-- Show thumbnail if only one person, otherwise show count -->
        <template v-if="region.singlePerson">
          <div class="single-person-thumbnail" :style="{ backgroundImage: `url(${region.singlePerson.thumbnail || '/thumbnails/placeholder.png'})` }"></div>
        </template>
        <template v-else>
          <p>{{ region.people.length }}</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import dataService from '../services/dataService'

export default {
  name: 'RegionList',
  data() {
    return {
      regions: [],
      peopleByRegion: {}
    }
  },
  computed: {
    regionsWithData() {
      return this.regions.map(region => {
        // Get the people for this region from our cache
        const regionPeople = this.peopleByRegion[region.id] || [];
        
        // If there's exactly one person, include their data
        const singlePerson = regionPeople.length === 1 ? regionPeople[0] : null;
        
        return {
          ...region,
          singlePerson
        };
      });
    }
  },
  methods: {
    selectRegion(region) {
      this.$emit('region-selected', region)
    },
    async loadPeopleData() {
      // For each region, load the people data if there's exactly one person
      for (const region of this.regions) {
        if (region.people.length === 1) {
          try {
            const people = await dataService.getPeopleByRegion(region.id);
            this.peopleByRegion[region.id] = people;
          } catch (error) {
            console.error(`Error loading people for region ${region.id}:`, error);
            this.peopleByRegion[region.id] = [];
          }
        } else {
          // For regions with multiple people, we don't need to fetch details
          this.peopleByRegion[region.id] = [];
        }
      }
    }
  },
  async mounted() {
    try {
      this.regions = await dataService.getRegions();
      await this.loadPeopleData();
    } catch (error) {
      console.error('Error loading regions:', error);
      this.regions = [];
    }
  }
}
</script>

<style scoped>
.region-list {
  /* padding: 2rem; */
}

.regions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
}

.region-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  width: 55px;
  height: 63px;
  background: url('/pin.png');
  background-size: 100% 100%;
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  font-size: 1.5rem;
  position: absolute;
}

.single-person-thumbnail {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  border: 2px solid #000;
}

.region-card:hover {
  transform: translateY(-5px);
}

.region-card.north-region {
    top: 20%;
    left: 15%;
}

.region-card.east-region {
  top: 35%;
  left: 23%;
}

.region-card.central-region {
  top: 38%;
  left: 18%;
}

.region-card.west-region {
  top: 32%;
  left: 13%;
}

.region-card.south-region {
  top: 20%;
  right: 15%;
}

.region-card.florida-region {
    left: 26.8%;
    top: 44%;
}

.region-card.connecticut-region {
    left: 28%;
    top: 36%;
}

.region-card.north-carolina {
    left: 26%;
    top: 39%;
}
</style>